import React from 'react';
import { Button, Snackbar } from '@material-ui/core';

import SnackConfig, { SnackConfigMessageType } from '../config/snackConfig';

interface SnackbarAlertProps {
  snackConfig: SnackConfig;
  setSnackConfig(config: SnackConfig): void;
}

// TODO: Proper UI based on various types
const SnackbarAlert: React.FC<SnackbarAlertProps> = ({ snackConfig, setSnackConfig }: SnackbarAlertProps) => {
  const { open, message, type } = snackConfig;

  if (open && type === SnackConfigMessageType.Error) {
    console.error(`[SnackbarAlert] ${message}`);
  }
  const handleClose = () => {
    setSnackConfig(new SnackConfig({}));
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
      message={<span id="message-id">{message}</span>}
      action={[
        <Button key="undo" color="secondary" size="small" onClick={handleClose}>
          Close
        </Button>,
      ]}
    />
  );
};

export default SnackbarAlert;
